/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cad_Features_Layouts_TitleInputs */

const en_cad_features_layouts_title = /** @type {(inputs: Cad_Features_Layouts_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Paper space that plots to scale`)
};

/**
* | output |
* | --- |
* | "Paper space that plots to scale" |
*
* @param {Cad_Features_Layouts_TitleInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const cad_features_layouts_title = /** @type {((inputs?: Cad_Features_Layouts_TitleInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cad_Features_Layouts_TitleInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_cad_features_layouts_title(inputs)
});
export { cad_features_layouts_title as "cad.features.layouts_title" }